<template>
    <div v-if="view">
        <div style="background: #fff">
            <div class="module">
                <img src="../img/mengban.png" alt style="width: 100%" />
                <div
                    class="item"
                    style="
                        width: 180px;
                        height: 180px;
                        top: 99%;
                        z-index: 1;
                        box-shadow: 0 0.04rem 0.16rem 0 rgba(0, 157, 133, 0.15);
                        border-radius: 0.2rem;
                    "
                >
                    &nbsp;
                </div>
                <div
                    class="item"
                    style="top: 99%; width: 160px; height: 160px; z-index: 1"
                    @click="showPop()"
                >
                    <vue-qr
                        :text="url"
                        :margin="0"
                        colorDark="#000"
                        colorLight="#fff"
                        :logoSrc="logoUrl"
                        :logoScale="0.2"
                        :size="400"
                    ></vue-qr>
                </div>
            </div>
            <p class="text1">请引导用户使用微信扫码购买</p>
        </div>
        <div class="info">
            <div class="span">
                <span class="span1">
                    <i style="color: #dd2b1e; font-size: 0.3rem">¥</i>
                    <i style="color: #dd2b1e; font-size: 0.44rem">{{ info.salePrice }}</i
                    >&nbsp;
                    <!-- <i style="color:#AAAAAA;font-size:0.2rem">¥</i>
          <i
            style="color:#AAAAAA;font-size:0.3rem;text-decoration:line-through;"
          >{{info.originPrice}}</i> -->
                </span>
                <span class="span2" v-if="info.isAgent == '1' && info.integral > '0'"
                    >每成功销售一单可得
                    {{ info.integral ? info.integral : '0' }} 积分</span
                >
                <span class="span2" v-if="info.isAgent == '0'" @click="show2 = true"
                    >成为代理可赚积分</span
                >
            </div>
            <h1>{{ info.title }}</h1>
            <p>{{ info.subTitle }}</p>
        </div>

        <merchant
            :list="info.marketingList"
            :tab="tabs"
            :years="info.years"
            :skuNo="info.skuNo"
            v-if="info.packType == '2'"
        ></merchant>

        <div class="item3" v-if="info.goodsType === '8' || info.goodsType === '9'">
            <div class="cell" id="shangpinfuwu" @click="showSubGoods">
                <span>商品包含以下服务</span>
                <van-icon name="arrow" color="#999" />
            </div>
        </div>
        <div
            class="item4"
            v-show="info.serviceDetailsList && info.serviceDetailsList.length"
        >
            <van-tabs v-model="serviceDetailIndex" class="sd-tab" scrollspy sticky>
                <van-tab
                    v-for="(sd, i) in info.serviceDetailsList"
                    :title="sd.title"
                    :key="i"
                >
                    <div
                        class="txt ql-editor"
                        v-if="info.serviceDetailsList && info.serviceDetailsList.length"
                        v-html="sd.detail"
                        id="htmlText"
                    ></div>
                </van-tab>
            </van-tabs>
        </div>

        <div v-show="show" class="van-overlay">
            <div class="erCodeBOX" @touchstart="touchstart()" @touchend="touchend()">
                <vue-qr
                    :text="url"
                    :margin="0"
                    colorDark="#000"
                    colorLight="#fff"
                    :logoSrc="logoUrl"
                    :logoScale="0.2"
                    :size="400"
                    class="qrCodeStyle"
                ></vue-qr>
                <p class="bottomFont">微信扫码打开 或 长按保存至相册</p>
            </div>
            <img class="close" @click="closePop()" src="../img/ico_close.png" alt />
        </div>
        <van-popup
            v-model="imageShow"
            class="save-image-popup"
            position="bottom"
            :style="{ height: '20%' }"
        >
            <van-button type="default" @click="saveImage()">保存图片</van-button>
            <van-button type="default" @click="cancelSaveImage()">取消</van-button>
        </van-popup>

        <van-overlay :show="show2">
            <div class="wrapper">
                <div
                    class="block"
                    style="
                        height: 5.9rem;
                        width: 5.9rem;
                        background: rgba(255, 255, 255, 1);
                        border-radius: 24px;
                        text-align: center;
                    "
                >
                    <img
                        src="../img/tou.png"
                        alt=""
                        style="width: 3.4rem; margin-top: -1.3rem"
                    />
                    <p style="color: #333333; font-size: 0.32rem; padding: 0 0.5rem">
                        您还不是代理人，成为代理人后，就可以赚取积分啦!
                    </p>
                    <div class="button" @click="to()">查看晋升规则</div>
                </div>
                <img
                    src="../img/ico_close.png"
                    style="width: 0.6rem; padding-top: 0.4rem"
                    @click="show2 = false"
                />
            </div>
        </van-overlay>

        <van-popup
            v-model="shangpinfuwu"
            position="bottom"
            round
            :close-on-click-overlay="false"
        >
            <div class="item-list-popup" id="shangpinfuwutankuang">
                <div class="header">
                    <span>商品包含以下服务</span>
                    <img @click="shangpinfuwu = false" src="../img/ico_close.svg" />
                </div>
                <div class="detail-list">
                    <div class="detail-item" v-for="(item, index) in items" :key="index">
                        <packageItem
                            :item="item"
                            @tipClick="tipClick(item)"
                        ></packageItem>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup
            v-model="tipPopup.show"
            position="center"
            round
            style="overflow-y: initial"
            :close-on-click-overlay="false"
        >
            <div class="item-tip-popup">
                <div class="header">使用说明</div>
                <img
                    class="close"
                    @click="tipPopup.show = false"
                    src="../img/ico_close4.svg"
                />
                <div class="description">
                    {{ tipPopup.item && tipPopup.item.description }}
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import vueQr from 'vue-qr';
import merchant from '../../common/merchant/merchant';
import packageItem from './../activityGoods/package-item';

export default {
    name: 'goodsDetail',
    components: {
        vueQr,
        merchant,
        packageItem,
    },
    data() {
        return {
            info: {},
            view: false,
            show: false,
            show2: false,
            shareMemberId: '',
            skuNo: '',
            assistantType: '',
            showUrl: '',
            title: '',
            Loop: 0,
            logoUrl: require('../img/pic_uniondrug.png'),
            dataUrl: '',
            erCode: '',
            imageShow: false,
            isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            url: '',
            tabs: [],

            shangpinfuwu: false,
            serviceDetailIndex: 0,
            tipPopup: {
                show: false,
                item: null,
            },
            items: [],
        };
    },
    created() {
        if (this.$route.query.shareMemberId && this.$route.query.skuNo) {
            this.shareMemberId = this.$route.query.shareMemberId;
            this.skuNo = this.$route.query.skuNo;
            if (this.$route.query.assistantType) {
                this.assistantType = this.$route.query.assistantType;
            }
            this.detail(); 
        }
    },
    methods: {
        to() {
            this.$router.push('/guize');
        },
        detail() {
            let post = {
                shareMemberId: this.shareMemberId,
                skuNo: this.skuNo,
                assistantType: this.assistantType,
            };
            this.$api.goodsDetail(post).then((res) => {
                if (res.errno == '0') {
                    if (!res.data.title && !res.data.subTitle && !res.data.salePrice) {
                        this.$toast('该商品未在分销渠道上架');
                    } else {
                        this.info = res.data;
                        // this.tabs = this.info.items.filter(
                        //     (item) => item.isMarketing != '1'
                        // );
                        document.title = this.info.title;
                        this.view = true;
                        if (this.info.detailUrl) this.share();
                        this.url = res.data.detailUrl;
                    }
                     this.setInitialPoint();//初始化埋点
                }
            });
        },

        //使用sensor1.22.6埋点 
        setInitialPoint(){
            // 商品sku 商品名字 商品售价 商品主类型 商品子类型 店员id 店员名称 门店id 门店名称
            const {
                skuNo,
                title,
                salePrice,
                productType,
                productTypeText,
                productSubtype,
                productSubtypeText,
                assistantId,
                assistantName,
                storeId,
                storeName,
            } = this.info;
            this.$newTrackFn.send('FX_assistant_productdetail_view', {
                product_sku:skuNo,
                product_name:title,
                product_price:salePrice,
                product_type:`${productType}:${productTypeText}`,
                product_subtype:`${productSubtype}:${productSubtypeText}`,
                assistant_id:assistantId,
                assistant_name:assistantName,
                store_id:storeId,
                store_name:storeName,
            });
        },

        showSubGoods() {
            this.queryCommonSubGoods();
        },

        queryCommonSubGoods() {
            this.$api
                .getCommonSubGoodsList({
                    skuNo: this.skuNo,
                })
                .then((res) => {
                    if (res.errno == '0') {
                        const { items } = res.data;
                        this.items = items;
                        this.tabs = items.filter((item) => item.isMarketing != '1');
                        this.shangpinfuwu = true;
                    }
                });
        },

        share() {
            let shareDate = {
                shareLink: this.info.detailUrl,
                shareTitle: this.info.title,
                shareDescr: this.info.subTitle,
                shareImg: this.info.coverImg,
                type: 0,
            };
            console.log('分享数据', shareDate);
            this.$bs.serviceShare(shareDate).then((e) => {
                if (e.status == '1') {
                    this.$toast('分享成功');
                } else if (e.msg) {
                    this.$toast(e.msg);
                }
            });
            this.$bs.setShareHidden({ type: 0 }).then((e) => {
                console.log('e', e);
                if (e.status == '1') {
                    this.$toast('开启成功');
                } else if (e.msg) {
                    this.$toast(e.msg);
                }
            });
        },
        showPop() {
            let oQrcode = document.querySelectorAll('.erCodeBOX img');
            this.erCode = oQrcode[0].src;
            this.show = true;
        },
        closePop() {
            this.show = false;
        },
        //长按保存图片
        touchstart() {
            if (!this.isiOS) {
                this.dataUrl = this.erCode;
                clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
                this.Loop = setTimeout(() => {
                    this.imageShow = true;
                }, 700);
            }
        },
        //清除定时器
        touchend() {
            clearInterval(this.Loop);
        },
        //图片保存
        saveImage() {
            this.$bs.downImage({ base64: this.dataUrl }).then((e) => {
                if (e.msg) {
                    this.$toast(e.msg);
                }
            });
            this.imageShow = false;
        },
        cancelSaveImage() {
            this.imageShow = false;
        },
        //  第一个参数是图片的URL地址，第二个是转换成base64地址后要赋值给的img标签
        getBase64Image(url) {
            let that = this;
            let image = new Image();
            image.crossOrigin = '*'; // 支持跨域图片
            image.src = url + '?v=' + Math.random(); // 处理缓存
            image.onload = function () {
                that.drawBase64Image(image);
            };
        },
        drawBase64Image(img) {
            var canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, img.width, img.height);
            this.dataUrl = canvas.toDataURL('image/png');
        },
        tipClick(item) {
            this.tipPopup.show = true;
            this.tipPopup.item = item;
        },
    },
};
</script>
<style lang="scss" scoped>
.module {
    position: relative;
    display: inline-grid;
    background: #fff;
    width: 100%;
    .item {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateY(-50%);
        display: flex;
        flex-flow: wrap;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 1);
        #qrcode {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            width: 4rem;
            height: 4rem;
            margin: auto;
            .qrcode__logo {
                width: 0.7rem;
                height: 0.7rem;
                position: absolute;
                right: 0;
                left: 0;
                bottom: 0;
                top: 0;
                margin: auto;
                display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
                display: -moz-box; /* 老版本语法: Firefox (buggy) */
                display: -ms-flexbox; /* 混合版本语法: IE 10 */
                display: -webkit-flex; /* 新版本语法: Chrome 21+ */
                display: flex;
                align-items: center;
                justify-content: center;
                .codeImg {
                    width: 0.7rem;
                }
            }
        }
    }
}
.info {
    margin: 0.2rem 0;
    padding: 0.4rem 0.3rem;
    background: #fff;
    .span {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .span1 {
            i {
                font-style: normal;
            }
        }
        .span2 {
            padding: 0.12rem 0.2rem;
            width: fit-content;
            font-size: 0.24rem;
            color: #ff8e00;
            background: rgba(255, 142, 0, 0.05);
        }
    }
    h1 {
        padding: 0.4rem 0;
        color: #333333;
        font-size: 0.36rem;
    }
    p {
        color: #888888;
        font-size: 0.28rem;
    }
}

.item1,
.item2,
.item3,
.item4 {
    background: #fff;
    border-radius: 16px;
    padding: 0.4rem 0.3rem 0.2rem;
    margin-bottom: 0.2rem;
}
.item3 {
    padding-top: 0.43rem;
    padding-bottom: 0.43rem;
    .cell {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        span {
            font-size: 0.3rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 0.3rem;
        }
    }
}
.item4 {
    padding-top: 0;

    ::v-deep.sd-tab.van-tabs {
        .van-tabs__wrap {
            height: 1rem;
        }
        .van-tab {
            max-width: 33%;
            min-width: 33%;
            /*flex: none !important;*/

            .van-tab__text {
                font-size: 0.32rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #999;
                line-height: 0.32rem;
            }
            &.van-tab--active .van-tab__text {
                color: #333;
            }
        }
        .van-tabs__line {
            width: 1.28rem;
            height: 0.06rem;
            background: linear-gradient(124deg, #f26b57 0%, #f83a2c 100%);
            border-radius: 0.03rem;
        }
    }
    ::v-deep.read-agerr.content {
        .read {
            padding-top: 0.24rem;
            a {
                color: #dd2b1e;
            }
        }
    }
    .ql-editor {
        padding-top: 0.24rem !important;
        ::v-deep {
            img {
                width: 100%;
                display: block;
                height: auto;
            }
        }
    }
}
.detail {
    padding: 0.4rem 0.3rem;
    background: #fff;
    h1 {
        color: #333333;
        font-size: 0.36rem;
    }
    .txt {
        margin: 0.4rem 0;
        p {
            img {
                width: 100% !important;
                display: block;
            }
        }
    }
}
.text1 {
    color: #ff9200;
    font-size: 0.28rem;
    text-align: center;
    margin-top: 2.1rem;
    padding-bottom: 0.6rem;
}
.wrapper {
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
    display: -webkit-flex; /* 新版本语法: Chrome 21+ */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    .block {
        position: relative;
        .qrcode__logo {
            width: 1.2rem;
            height: 1.2rem;
            background: #fff;
            position: absolute;
            top: 40%;
            left: 0;
            right: 0;
            margin: auto;
        }
    }
}
.button {
    width: 430px;
    height: 88px;
    line-height: 88px;
    margin: 0.8rem auto auto;
    background: linear-gradient(
        128deg,
        rgba(242, 107, 87, 1) 0%,
        rgba(221, 43, 30, 1) 100%
    );
    border-radius: 16px;
    font-size: 0.34rem;
    color: #fff;
}
.bottomFont {
    margin: -0.2rem 0px 0px !important;
    font-size: 0.3rem !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #616161 !important;
    line-height: 0.26rem !important;
    width: 100% !important;
    text-align: center;
}
.van-overlay {
    background: rgba(0, 0, 0, 0.5) !important;
}
.close {
    width: 60px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    margin-top: 60px;
}
.erCodeBOX {
    width: 6.22rem;
    height: 6.72rem;
    background: white;
    border-radius: 0.2rem;
    margin: 164px auto 0;
    overflow: hidden;
}
.qrCodeStyle {
    padding: 50px;
    width: 520px;
}
.save-image-popup {
    z-index: 10000000000 !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    .van-button {
        width: 90%;
        margin-bottom: 10px;
        border-radius: 10px;
        height: 52px;
    }
    .van-button--default {
        color: #007aff;
    }
    .van-button--normal {
        font-size: 20px;
    }
}

::v-deep#merchant {
    .item-2,
    .item-3 {
        display: none;
    }
}
.item-list-popup {
    background: #ffffff;
    padding: 0 0.3rem;
    display: flex;
    flex-direction: column;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.4rem 0;

        span {
            font-size: 0.36rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 0.36rem;
        }

        img {
            width: 0.44rem;
            height: 0.44rem;
        }
    }
    .detail-list {
        max-height: 6rem;
        overflow-y: auto;
        &::-webkit-scrollbar {
            display: none;
        }
    }
}
.item-tip-popup {
    background: #ffffff;
    border-radius: 0.24rem;
    padding: 0.4rem;
    padding-bottom: 0.32rem;
    display: flex;
    flex-direction: column;
    width: 90vw;
    max-height: 8rem;
    min-height: 6rem;
    box-sizing: border-box;
    position: relative;

    .header {
        font-size: 0.36rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3a3a3a;
        line-height: 0.36rem;
        text-align: center;
    }
    .close {
        position: absolute;
        width: 0.6rem;
        height: 0.6rem;
        left: 50%;
        bottom: -1.2rem;
        transform: translateX(-50%);
    }
    .description {
        flex: 1;
        margin-top: 0.32rem;
        overflow-y: auto;
    }
}
</style>
